import { create } from "zustand";
import { persist } from "zustand/middleware";
import * as cognitoAuth from "@/lib/cognitoAuth";

// nova 풀 Cognito 로그인(ADMIN_EMAILS 허용목록). 이전 공용 비밀번호 방식은 폐기 —
// 실제 로그인 계정이라 접근/조작 기록이 서버에 남는다.
const STORAGE_KEY = "novadb-auth";

export const useAuthStore = create(
  persist(
    (set, get) => ({
      idToken: null,
      refreshToken: null,
      expiresAt: null,
      email: null,
      loading: false,
      error: null,

      async signIn(email, password) {
        set({ loading: true, error: null });
        try {
          const tokens = await cognitoAuth.signIn(email, password);
          set({
            idToken: tokens.idToken,
            refreshToken: tokens.refreshToken,
            expiresAt: tokens.expiresAt,
            email,
            loading: false,
            error: null,
          });
          return { success: true };
        } catch (e) {
          set({ loading: false, error: e.message || "로그인에 실패했습니다." });
          return { success: false, error: e.message };
        }
      },

      signOut() {
        set({ idToken: null, refreshToken: null, expiresAt: null, email: null, error: null });
      },

      isAuthenticated() {
        return !!get().idToken;
      },

      // idToken 만료가 임박하면 refreshToken으로 조용히 갱신한다.
      async getValidIdToken() {
        const s = get();
        if (!s.idToken) return null;
        if (s.expiresAt && Date.now() < s.expiresAt - 60_000) return s.idToken;
        if (!s.refreshToken) return s.idToken;
        try {
          const tokens = await cognitoAuth.refreshTokens(s.refreshToken);
          set({ idToken: tokens.idToken, expiresAt: tokens.expiresAt });
          return tokens.idToken;
        } catch {
          get().signOut();
          return null;
        }
      },
    }),
    {
      name: STORAGE_KEY,
      storage: {
        getItem: (name) => {
          const v = sessionStorage.getItem(name);
          return v ? JSON.parse(v) : null;
        },
        setItem: (name, value) => sessionStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => sessionStorage.removeItem(name),
      },
      partialize: (state) => ({
        idToken: state.idToken,
        refreshToken: state.refreshToken,
        expiresAt: state.expiresAt,
        email: state.email,
      }),
    }
  )
);
